class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.onKeyup = this.onKeyup.bind(this);
    this.onTabKeydown = this.onTabKeydown.bind(this);
    this.onFocusEscape = this.onFocusEscape.bind(this);
    // On the document, not on the drawer. Escape only ever reaches a listener on the path
    // from document.activeElement up, and focus is not inside the drawer until the focus
    // trap arms at the end of the slide-in (armFocusTrap, STR-1409). Escape pressed before
    // then, from #cart-icon-bubble or <body>, must still close it.
    document.addEventListener('keyup', this.onKeyup);
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.addEventListener('click',(e)=>{
      let clickInsideDrawer = e.target.closest('#CartDrawer');

      if(!clickInsideDrawer){
        this.close();
      }
    })
  }

  disconnectedCallback() {
    document.removeEventListener('keyup', this.onKeyup);
    this.disarmFocusGuard();
  }

  onKeyup(evt) {
    if (evt.code !== 'Escape') return;
    // Guard on the open state: close() resets body styles and hands focus back to the
    // stored trigger, so a stray Escape anywhere on the page must not run it.
    if (!this.classList.contains('active')) return;
    this.close();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});
    // document.body.style.marginTop = '200px';
   
    if (!this.classList.contains('is-empty')) {
      document.body.classList.add('overlay');
    }
    setTimeout(()=>{
      if (!this.classList.contains('is-empty')) {
        document.body.classList.add('overlay');
      }
    },100)

    this.armFocusTrap();

    // if (this.classList.contains('is-empty')){
    //   console.log('Cart is empty');
    // }


    setTimeout(()=>{
      if (this.classList.contains('is-empty')) {

        setTimeout(() => {
          this.close()
        }, 1000);
      }
    },1000)
    let cartHeight = this.querySelector('#CartDrawer').offsetHeight;
    if(window.innerWidth > 749){
      document.body.style.marginTop = `${cartHeight}px`;
    }

    if(!this.classList.contains('is-empty')){
      document.body.classList.add('overflow-hidden');
    }
  }

  // STR-1409: trap focus once the drawer's own slide-in ends. transitionend bubbles, so an
  // unfiltered { once: true } listener was spent by whichever descendant transition finished
  // first and focus never entered the dialog. The sliding element is <cart-drawer> below
  // 750px and #CartDrawer above it. The timer covers opens with no transition to wait for
  // (reduced motion, a drawer that is already open).
  armFocusTrap() {
    const token = (this.focusTrapToken = {});
    const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
    // The guard below holds Tab inside from the moment the drawer opens, slide-in included.
    this.focusContainer = containerToTrapFocusOn;
    document.addEventListener('keydown', this.onTabKeydown);
    document.addEventListener('focusin', this.onFocusEscape);
    const arm = () => {
      this.removeEventListener('transitionend', onTransitionEnd);
      if (this.focusTrapToken !== token) return;
      this.focusTrapToken = null;
      if (!this.classList.contains('active')) return;
      // Leave focus where it is if the user has already tabbed into the drawer.
      const focusElement = containerToTrapFocusOn.contains(document.activeElement)
        ? document.activeElement
        : this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    };
    const onTransitionEnd = (event) => {
      if (event.propertyName !== 'transform') return;
      if (event.target !== this && event.target.id !== 'CartDrawer') return;
      arm();
    };
    this.addEventListener('transitionend', onTransitionEnd);
    setTimeout(arm, 1000);
  }

  // trapFocus only wraps when focus reaches its first or last focusable. Safari leaves links
  // and buttons out of the Tab order by default, so Tab there walks straight out of the
  // drawer. While the drawer is open, focus that Tab moves outside goes back to the first visible
  // focusable, or the last one on Shift+Tab: on focusin, and once more after each Tab for
  // the move to <body>, which fires no focusin.
  onTabKeydown(event) {
    if (event.key !== 'Tab') return;
    this.tabBackwards = event.shiftKey;
    this.tabbing = true;
    setTimeout(() => {
      this.onFocusEscape();
      this.tabbing = false;
    });
  }

  // Keyboard moves only: a click on header content while the drawer is open keeps its focus.
  onFocusEscape(event) {
    const container = this.focusContainer;
    if (!container || (event && !this.tabbing)) return;
    // Closed by something other than close() (CartItems.close() in cart.js empties the cart
    // and drops .active directly). While the open is still pending, .active is not on yet.
    if (!this.classList.contains('active') && !this.focusTrapToken) return this.disarmFocusGuard();
    if (container.contains(document.activeElement)) return;
    const visible = getFocusableElements(container).filter((el) => el.offsetWidth > 0 && el.offsetHeight > 0);
    const target = this.tabBackwards ? visible[visible.length - 1] : visible[0];
    if (target) target.focus();
  }

  disarmFocusGuard() {
    this.focusContainer = null;
    document.removeEventListener('keydown', this.onTabKeydown);
    document.removeEventListener('focusin', this.onFocusEscape);
  }

  close() {
    this.focusTrapToken = null;
    this.disarmFocusGuard();
    document.body.style.marginTop = 0;
    document.body.classList.remove('overlay');
    document.querySelector(".drawer").classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.style.marginTop = `0px`;
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    console.log('Drawer');
    document.body.classList.add('overflow-hidden');
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));


    
  
    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      // this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);




// FIX CART DRAWER HEIGHT ON MOBILE DEVICES
let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);
window.addEventListener('resize', () => {
  // We execute the same script as before
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});